<template>
  <span class="svg-icon-information">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM11.2423 9.18622C11.6607 9.60464 12.3391 9.60464 12.7575 9.18622C13.1759 8.7678 13.1759 8.08941 12.7575 7.67099C12.3391 7.25257 11.6607 7.25257 11.2423 7.67099C10.8239 8.08941 10.8239 8.7678 11.2423 9.18622ZM13.0713 15.5715V12C13.0713 11.4083 12.5916 10.9286 11.9999 10.9286C11.4082 10.9286 10.9285 11.4083 10.9285 12V15.5715C10.9285 16.1632 11.4082 16.6429 11.9999 16.6429C12.5916 16.6429 13.0713 16.1632 13.0713 15.5715Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } }
  }
}
</script>
